module.exports = __webpack_public_path__ + "img/guanyuwomen.22fa5579.jpg";